import React from 'react';
import classNames from 'classnames';

export const renderField = (field) => (
  <div className={'field'}>
    {field.label && <label>{field.label}</label>}
    {(field.type === 'textarea') ? (
      <textarea {...field.input}
                className={
                  classNames({
                    'invalid': field.meta.invalid,
                    'touched': field.meta.touched,
                  })
                }
                placeholder={field.placeholder}/>
    ) : (
      <input {...field.input}
             className={
               classNames({
                 'invalid': field.meta.invalid,
                 'touched': field.meta.touched,
               })
             }
             placeholder={field.placeholder}
             type={field.type}/>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/formUtilities.js